import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  position: relative;

  .subHeader-container {
    display: flex;
    align-items: center;
    background-color: ${colors.lightGreyTwo};
    height: 61px;
  }

  .title {
    font-size: 32px;
    color: ${colors.darkGray};
    font-weight: 300;
    display: flex;
    align-items: center;

    @media (max-width: 1024px) {
      font-size: 18px;
    }

    @media (max-width: 1024px) {
      padding-left: 20px;
    }
  }

  .title--first-word {
    font-weight: 500;
  }

  .help-container {
    cursor: pointer;
    display: inline-block;
    margin-left: 50px;
    color: ${colors.textButton};
    text-transform: uppercase;
    font-size: 14px;

    path {
      fill: ${colors.textButton};
    }
    rect {
      fill: ${colors.textButton};
    }
  }

  .text-help-container {
    background: ${colors.grayEight};
    font-size: 18px;
    font-weight: 300;
    line-height: 18px;
    min-height: 255px;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    z-index: 9999;
    opacity: 0;
    will-change: 'opacity';
    transition: opacity 0.5s;
    display: none;
  }

  .help-wrapper {
    display: flex;
    align-items: center;
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/SubHeader/style.js